import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { Subheader } from 'components';
import ArticleDetails from 'features/articles/ArticleDetails';
import { useAlerts, useArticles } from 'hooks';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const ArticleShow = ({ ...props }) => {
	const navigate = useNavigate();
	const { id } = useParams();

	const { articleId, isLoading, isLoaded, article, findArticle } = useArticles({
		id: id
	});

	const { showAlertSuccess, showAlertError } = useAlerts();

	const handleEditClick = () => navigate(`/articles/${id}/edit`);

	useEffect(() => {
		if (id) findArticle(id);
	}, []);

	return (
		<>
			<Subheader
				title={isLoading ? 'Loading...' : `Article ${article.id}`}
				buttons={[
					<Button onClick={handleEditClick} color="primary" variant="contained">
						Edit
					</Button>
				]}
			/>
			<Container>
				<Paper>
					<Box p={4}>
						<ArticleDetails article={article} />
					</Box>
				</Paper>
			</Container>
		</>
	);
};

export default ArticleShow;
